<template>
  <!-- AUTHENTICATED -->
  <div v-if="auth && !focus()" class="absolute top-0 w-full p-4 pt-8 bg-theme-pink/25">Welcome, {{ auth?.name }}!</div>

  <!-- NAVIGATION -->
  <nav v-if="auth && !focus()" class="flex flex-row flex-wrap justify-center gap-x-4 gap-y-0 mt-24 font-medium">
    <div v-for="tab in tabs" :key="tab" @click="$router.push({ name: tab })" class="hover:bg-gray-100 py-2 px-4 rounded-lg cursor-pointer" :class="{ 'bg-gray-100': selected() === tab }">{{ tab }}</div>
  </nav>

  <!-- BODY -->
  <RouterView/>

  <!-- FOOTER -->
  <div v-if="!focus()" class="mt-16 mb-8 text-theme-navy/50">Made with ❤ by Ella & Khanh.</div>
</template>

<script>
import Group from '@/models/group'

export default {
  name: 'App',
  created() {
    document.title = 'Save the date!';
  },
  data() {
    return {
      auth: undefined,
      tabs: [
        'Home',
        'Entourage',
        'Attire',
        'Schedule',
        'Recommendations',
        'Q&A',
      ],
    }
  },
  beforeMount() {
    this.loadAuth()
  },
  watch: {
    $route() {
      this.loadAuth()
    },
  },
  methods: {
    async loadAuth() {
      const secret = this.$route.query.group
      if (secret) {
        this.auth = await Group.auth(secret)
      } else {
        this.auth = await Group.current()
      }
    },
    selected() {
      return this.$route.name
    },
    focus() {
      return this.$route.path.startsWith('/rsvp')
       || this.$route.path.startsWith('/admin')
       || this.$route.path.startsWith('/login')
    },
  },
}
</script>
